import { ObjectId } from "../generated/Api";

export enum INoteType {
    "USER" = "USER",
    "SYSTEM" = "SYSTEM",
}

export interface INoteCategory {
    _id?: ObjectId | string;
    name: string;
    userUid: string;
    type: INoteType;
}

export interface CreateNoteCategoryIRoute {
    name: string;
    userUid: string;
    type: INoteType;
}

export interface FindAllNoteCategoriesFromUserIRoute {
    userUid: string;
}

export interface UpdateNoteCategoryIRoute {
    _id: string;
    name: string;
    type: INoteType;
}